/* unplugin-vue-components disabled */import { render } from "./tenant-access-prompt.vue?vue&type=template&id=7ce93489"
import script from "./tenant-access-prompt.vue?vue&type=script&lang=js"
export * from "./tenant-access-prompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__